module.exports = __webpack_public_path__ + "img/user-icon.6590348f.svg";